import React from 'react';
import { connect } from 'react-redux';
import { Modal, Row, Col, Button, Tooltip, Icon } from 'antd';
import { CreditCardOutlined, EditOutlined, FileAddOutlined } from '@ant-design/icons'
import { serviceFields } from '../../const/simbix';
import { getValues } from '../../virtuoso/helper'
import { AdmsAsset, RdfTriplet } from '../../redux';
import SelectProperty from '../widgets/SelectProperty';
import { filterAddedPredicates } from '../../views/helper';
import { FieldViewProxy, FieldEditProxy } from '../adms/FieldProxies';
import { getSelectedIRI } from '../editor/helper';
import SelectIndividualForm from '../editor/SelectIndividualForm';
import PropertyLabel from '../owl/ProperyLabel';

/** Отображение списка значений для карточки ADMS
 * Формируется таблица, содержащая столбец с названием поля и столбец со значением поля
 * Для отображения поля используются специальные компоненты. Виды компонент описаны в widgets.
 * Получает список 
 */
const sortedStartPart = ['http://www.w3.org/1999/02/22-rdf-syntax-ns#about', 'http://purl.org/dc/terms/title',
    'http://www.w3.org/1999/02/22-rdf-syntax-ns#type'];
const sortedFinishPart = ['http://www.w3.org/ns/dcat#accessURL', 'http://www.w3.org/ns/dcat#downloadURL',
    'http://purl.org/dc/terms/issued', 'http://www.w3.org/ns/dcat#byteSize'];
const exclude = ['NName', 'http://www.w3.org/1999/02/22-rdf-syntax-ns#type'];

//Фильтрует полученные свойства для отображения. Исключает служебные свойства, свойства с пустыми значениями
//predicates содержит все предикаты, имеющие значения
const filterForShow = (predicates, values) => {
    //if (predicates) return predicates;
    //Исключаем служебные элементы
    const first = predicates.filter(key => !serviceFields.includes(key)); 
    //Исключаем свойства, которые не должны показываться
    const properties = first.filter(key => !exclude.includes(key));
    //Формируем последовательность свойств для отображения
    //console.log(properties)
    return properties.sort ((a, b) => {
            //console.log("0", a, b);
            //Начало списка свойств
            let indexA = sortedStartPart.indexOf(a);
            let indexB = sortedStartPart.indexOf(b);
            //console.log("1", indexA, indexB);
            if (indexA>-1){
                if (indexB>-1) return indexA-indexB;
                return -1;
            };
            if (indexB>-1) return 1;
            //конец списка свойств
            indexA = sortedFinishPart.indexOf(a);
            indexB = sortedFinishPart.indexOf(b);
            //console.log("2", indexA, indexB);
            if (indexA>-1){
                if (indexB < 0) return 1;
                return indexA-indexB;
            };
            if (indexB>-1) return 1;
            return 0;
        });
}

/**
 * 
 * @param {*} formRef 
 * @param {*} IRI - текущий выбранный элемент (IRI)
 * @param {*} factory - фабрика получения информкции о списка доступных свойств и их аннотации
 * @param {*} existing - массив существующих у объекта свойств (предикат + объекта)
 * @param {*} lang  - текущий язык
 * @param {*} onFinishOperation - callback для добавления
 * @param {*} onCancelOperation - callback для отмены
 * @returns 
 */
const showAddProperty = (formRef=f=>f, IRI, existing, factory, lang, onFinishOperation=f=>f, onCancelOperation=f=>f) => {
  //console.log("syncPercent", syncPercent);
  return <Modal style={{minWidth: "80%"}} open={true} title="Добавление свойства" cancelText="Отмена" okText="Ок" 
    onCancel={onCancelOperation} onOk={onFinishOperation} destroyOnHidden>
        <SelectProperty formRef={formRef} subjectIri={IRI} existing={existing} 
          factory={factory} lang={lang}/>
    </Modal>
}

/** Показать диалог выбора индивидуала */
const showSelectIndividual = (formRef=f=>f, IRI, predicat, factory, lang, onFinishOperation=f=>f, onCancelOperation=f=>f, selected) => {
  //console.log("syncPercent", syncPercent);
  return <Modal style={{minWidth: "80%"}} open={true} title="Выбор элемента" cancelText="Отмена" okText="Ок" 
    onCancel={onCancelOperation} onOk={onFinishOperation} okButtonProps={{disabled: !getSelectedIRI(selected)}}>
        <SelectIndividualForm formRef={formRef} IRI={IRI} predicat={predicat}
          factory={factory} lang={lang}/>
    </Modal>
}

const { confirm } = Modal;
/** Формирует выподающий список для операций */
const ButtonGroup = Button.Group;

/** Базовая компонента отображения свойств
 */
class AssetDistributionCard extends React.Component {
    state = {
        selected: undefined,    //Свойство (predicat), которое редактируется, удаляется или для него осуществляется перерво
        operation: "view",      //Текущая операция. Может быть view, edit, delete

      adding: false,            //Флаг, для отображения далога добавления нового свойства
      addedPredicates: [],      //Добавленные предикаты

      linkSelectModal: false,
      linkSelectSubject: undefined,
      linkSelectPredicat: undefined,
      linkSelectResolve: undefined,
      linkSelectReject: undefined,
    }

    formRef = React.createRef();

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.values !== this.props.values && this.state.addedPredicates.length > 0) {
        const addedPredicates = filterAddedPredicates(
            this.state.addedPredicates,
            this.props.values
        );

        if (addedPredicates.length !== this.state.addedPredicates.length) {
            this.setState({ addedPredicates });
            return;
        }
        };
    };

    /** Обработчик действий над элементом в форме  */
    onAction (e, type, predicat) {
      e.preventDefault();
      console.log("AssetDistributionCard.js onAction", e, type, predicat); console.log(this); 
      //Режим редактирования, удаления или перевода
      if ((type=="edit")||(type=="translate")){
        const value = getValues(predicat, this.props.lang, this.props.values);
        this.props.onSelected(type, this.props.iri, predicat, value);
        return;
      }
        if (type=="delete"){
            const { iri, onRemoveProperty } = this.props;
            const value = getValues(predicat, this.props.lang, this.props.values);
            confirm({
                title: 'Удалить выбранное свойство?',
                content: value,
                okText: 'Да',
                okType: 'danger',
                cancelText: 'Нет',
                onOk() {
                  console.log('OK', iri, predicat);
                  onRemoveProperty(iri, predicat);
                },
                onCancel() {
                    //this.setState({selected: predicat, operation: "view"})
                },
              });
            return;
        }
        if (type=="cancel"){
            this.setState({selected: predicat, operation: "view"})
            return;
        }
        if (type=="detail"){
            const {handlers} = this.props;
            if (handlers) handlers(e, predicat, type);
        }
              //Добавление новой ссылки в собъектное совойства
        if (type=="link"){
          this.setState({selectedIndividual: true, objectProperty: predicat});
      }
    }

  /** Вызывается после изменений при редактировании полей */
  onReloadProxy(subject, predicat){
    const {graph, onReload} = this.props;
    return onReload(subject, graph);
  };

  onSelectOperation(e, operation) { 
    e.preventDefault();    
    //Добавление нового свойства
    if (operation=="add"){
      this.setState({adding: true});
      return;
    };    
    this.setState({operation});
  }

  submitAddProperty() {
    this.setState({adding: false, operation: "edit"});
    const form  = this.formRef.current;
    form.validateFields()
     .then((values) => {
        const addedPredicates = [ ... this.state.addedPredicates, {object:{state: 'new'}, predicat : {type: 'uri', value: values.predicateIri}}];
        this.setState({selected: values.predicateIri, adding: false, operation: "edit", addedPredicates});
    }).catch((errorInfo) => {
      console.log(errorInfo);
    });
  };

  cancelOperation(){
    this.setState({selected: undefined, operation: "view", adding: false});
  }

    onSelectLink = ({ subject, predicat, factory }) => {
    return new Promise((resolve, reject) => {
        this.setState({ linkSelectModal: true, linkSelectSubject: subject, linkSelectPredicat: predicat,
          linkSelectResolve: resolve, linkSelectReject: reject,
        });
      });
  };

  onSelectLinkOk = () => {
    const { linkSelectResolve } = this.state;

    const selectedIRI = getSelectedIRI(this.props.vselected);

    if (!selectedIRI) {
      if (linkSelectResolve) {
        linkSelectResolve(undefined);
      }

      this.setState({ linkSelectModal: false,linkSelectSubject: undefined, linkSelectPredicat: undefined,
        linkSelectResolve: undefined, linkSelectReject: undefined, });

      return;
    }

    if (linkSelectResolve) { linkSelectResolve(selectedIRI); }

    this.setState({ linkSelectModal: false, linkSelectSubject: undefined, linkSelectPredicat: undefined, 
      linkSelectResolve: undefined, linkSelectReject: undefined });
  };

  onSelectLinkCancel = () => {
    const { linkSelectReject } = this.state;

    if (linkSelectReject) { linkSelectReject(new Error("Выбор объекта отменён.")); }

    this.setState({ linkSelectModal: false, linkSelectSubject: undefined, linkSelectPredicat: undefined,
      linkSelectResolve: undefined, linkSelectReject: undefined, });
  };  

  onAppendLink = (subject, predicat, objectIRI) => {
    const { onInsertProperty, onReload, graph } = this.props;
    onInsertProperty(RdfTriplet, subject, predicat, objectIRI)
      .then (result =>{
          //Обновим каталог
          if (onReload)
            onReload(subject, graph).then(result2=> {
              message.success(i18n.t('components.editor.individual.message.ok_new'));
            });
          else{
            message.success("Для просмотра изменений перегрузите страницу.");
          };
      })
      .catch(info => {
        message.error(i18n.t('components.editor.individual.message.e_new', {detail: info}));
      });
  };

  onDeleteLink = (subject, predicat, objectIRI) => {
    const { onDeleteElement, onReload, graph } = this.props;
    onDeleteElement(RdfTriplet, subject, predicat, objectIRI)
      .then (result =>{
        //Обновим каталог
        if (onReload)
          onReload(subject, graph).then(result2=> {});
        else  
          message.success("Для просмотра изменений перегрузите страницу.");
      })
      .catch(info => {
        message.error(i18n.t('components.editor.individual.message.e_unlink', {detail: info}));
      });
  };

  render(){
    const {operation, predicates, values, lang, factory, IRI, onReload, isSignedIn, inGroup, vselected} = this.props;
    const {addedPredicates, adding} = this.state;
    const properties = filterForShow(predicates, values);
    const addedProperies = Array.isArray(addedPredicates)? addedPredicates.map(item => item.predicat.value):[];
    const FieldProxy = (operation=="edit")? FieldEditProxy: FieldViewProxy;
    const linkProps = {
      onSelectLink: this.onSelectLink,
      onAppendLink: this.onAppendLink,
      onDeleteLink: this.onDeleteLink,
      //onNewLink: this.onNewLink,
    };
    const labelStyle = operation=="edit" ? { color: '#bfbfbf' } : undefined;
    console.log(this);
    return (
      <table className="big-rubber-blk" style={{width: "100%"}}>
        <tbody>
            <TopRow />
            <tr className="middle-row">
                <td className="middle-left-col"></td>
                <td className="blk-body">
                    <div className="assetCardTable_tr">
                        <Row style={labelStyle}> 
                            <Col span={10}><div className="assetCardTable_td" style={{width:"100%", float:"left"}}><div className="csi_field_div">URI</div></div></Col>
                            <Col span={14}><div className="assetCardTable_td"><div className="csi_value_div">{IRI}</div></div></Col>
                        </Row>
                    </div>
                </td>
                <td className="middle-right-col"></td>
            </tr>
            {properties.map((prop, i) => 
            <tr key={i} className="middle-row">
                <td className="middle-left-col"></td>
                <td className="blk-body">
                    <div className="assetCardTable_tr">
                        <Row key={i}> 
                            <Col span={10}>
                        <div className="assetCardTable_td" style={{width:"100%", float:"left"}}>
                            <PropertyLabel iri={prop} factory={factory} isEdit={operation=="edit"}/>
                        </div>
                            </Col>
                            <Col span={14}>
                        <div className="assetCardTable_td">
                            <FieldProxy 
                                factory={factory} lang={lang} 
                                subject={IRI} predicat={prop} values={values}
                                onReload={(subject, predicat) => this.onReloadProxy(subject, predicat)}
                                {...this.state} 
                                {...linkProps}/>
                        </div>
                            </Col>
                        </Row>
                    </div>
                </td>
                <td className="middle-right-col"></td>
            </tr>
            )}
        {Array.isArray(addedProperies) && 
          addedProperies.map((prop, i) => 
<tr key={i} className="middle-row">
    <td className="middle-left-col"></td>
    <td className="blk-body">
        <div className="assetCardTable_tr">
            <Row key={prop} className="assetCardTable_tr"> 
              <Col span={10} className="assetCardTable_td">
                <PropertyLabel iri={prop} factory={factory} warning={true} />
              </Col>
              <Col span={14} className="assetCardTable_td" style={{display: "block"}}>
                <FieldProxy 
                  factory={factory} lang={lang} 
                  subject={IRI} predicat={prop} values={values}
                  onReload={onReload}
                  {...this.state}
                  {...linkProps}
                  action={(e, type, predicat)=> this.onAction(e, type, predicat)}/>
              </Col>
            </Row>
        </div>
    </td>
    <td className="middle-right-col"></td>
</tr>
        )}
        
            <tr className="middle-row">
                <td className="middle-left-col"></td>
                <td className="blk-body">
          <Col align="right" span={24} style={{"flexDirection": "row-reverse"}}>
          {isSignedIn && inGroup.PowerUser && (
            <ButtonGroup>
              {adding && 
                showAddProperty(this.formRef, IRI, [...predicates, ...addedPredicates], factory, lang, 
                  ()=>this.submitAddProperty(), ()=>this.cancelOperation())
              }
              { operation && (operation != "view") && (
                <>
                  <Tooltip placement="top" title={"Добавление свойства"}>
                      <Button icon={<FileAddOutlined />} onClick={(e)=> this.onSelectOperation(e, "add")}/>
                  </Tooltip>
                    {/* &nbsp;&nbsp;
                  <Tooltip placement="top" title={"Режим просмотра данных"}>
                    <Button type="primary" icon={<CreditCardOutlined />} onClick={(e)=> this.onSelectOperation(e, "view")} />
                  </Tooltip> */}
                </>
              )}
              {/* {operation !="edit" && (
                <Tooltip placement="top" title={"Режим редактирования"}>
                  <Button icon={<EditOutlined />} onClick={(e)=> this.onSelectOperation(e, "edit")}/>
                </Tooltip>
              )} */}
            </ButtonGroup>
          )}
          </Col>
                </td>
                <td className="middle-right-col"></td>
            </tr>
        {this.state.linkSelectModal && showSelectIndividual(this.formRef, IRI, this.state.linkSelectPredicat, factory, lang, this.onSelectLinkOk, this.onSelectLinkCancel, vselected)}
            <BottomRow />
        </tbody>
    </table>
        )
        }
}

const TopRow = () => 
    <tr className="top-row">
        <td className="top-left-corner"></td>
        <td className="top-middle"></td>
        <td className="top-right-corner"></td>
    </tr>
const BottomRow = () =>
    <tr className="bottom-row">
        <td className="bottom-left-corner"></td>
        <td className="bottom-middle"></td>
        <td className="bottom-right-corner"></td>
    </tr>

function mapStateToProps(state, props) {
    //Значения в store redux
    const {vasset, vset, vselected } = state;
    const {lang, IRI} = props;
    const items = vasset.distributions.filter(item => item.object.value == IRI);
    const values = (items && Array.isArray(items) && items.length>0)? items[0].values: null;
    const predicates = (values && Array.isArray(values))?[...new Set(values.map(item => item.predicat.value))]:[];
    return {
      lang: (lang)?lang: vset.lang,
        isSignedIn: vset.isSignedIn,
        inGroup: vset.inGroup,
      vselected,
      distributions: vasset.distributions,      //Текущие данные
      predicates,
      values,
    };
}
export default connect(mapStateToProps,
    dispatch => ({
        onReload(subject, graph){
            return RdfTriplet.loadSubject(subject, graph).then(response =>{
                const {bindings, head} = response;
                return dispatch(AdmsAsset.RELOAD_DISTRIBUTION(subject, bindings));
            });
        },
        onSelected(type, subject, prdicat, object){
          return dispatch(RdfTriplet.SELECTED(type, subject, prdicat, object));
        },
        onRemoveProperty(subject, predicat){
          return dispatch(AdmsAsset.removeProperty(subject, predicat));
        },
        onInsertProperty(actions, subject, predicat, uri){
        return dispatch(actions.insertTripleURI(subject, predicat, uri));
        },
      })
)(AssetDistributionCard);